import { ActionExecutionLocation, type ActionProperties } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { getBlueprintIdFromActionProperties } from "~/areas/projects/components/Process/Blueprints/blueprintId";
import { useProcessBlueprintsFromContext } from "~/areas/projects/components/Process/Contexts/ProcessBlueprintsContextProvider";
import { TargetRoles } from "~/areas/projects/components/Process/types";
import pluginRegistry from "~/components/Actions/pluginRegistry";
import convertPropertyValueResourceToString from "~/components/convertPropertyValueResourceToString";
function Summary(action: ActionProperties) {
    const blueprints = useProcessBlueprintsFromContext();
    const blueprintId = getBlueprintIdFromActionProperties(action);
    const blueprint = blueprints.find((b) => b.Id === blueprintId);
    if (!blueprintId) {
        return <div>Run a process blueprint. No blueprint has been selected.</div>;
    }
    if (!blueprint) {
        const selectedGitRef = convertPropertyValueResourceToString(action["Octopus.Action.Blueprint.Reference.Commit"]).substring(0, 7) || convertPropertyValueResourceToString(action["Octopus.Action.Blueprint.Reference.Branch"]);
        const selectedSlug = convertPropertyValueResourceToString(action["Octopus.Action.Blueprint.Reference.Slug"]);
        return (<div>
                Run a process blueprint. The selected blueprint <strong>{selectedSlug}</strong> from <strong>{selectedGitRef}</strong> could not be found.
            </div>);
    }
    // Shouldn't ever show since we have a specific list item for blueprint steps that do exist, but using some sensible default.
    return <div>Run blueprint {blueprint.Name}</div>;
}
// Register plugin to satisfy contract of displaying deployment process step
// Blueprint steps will be displayed in separate component
pluginRegistry.registerAction({
    actionType: "Octopus.Blueprint",
    summary: Summary,
    editSections: {
        default: () => <></>,
        top: () => <></>,
    },
    canHaveChildren: (step) => false,
    canBeChild: false,
    executionLocation: ActionExecutionLocation.TargetOrServer,
    targetRoleOption: (action) => TargetRoles.Optional,
    hasPackages: (action) => false,
    features: {
        optional: [],
    },
});
